export default {
    getSelectedBook(state) {
        return state.selectedBook;
    },
    getBookCreatedNow(state) {
        return state.bookCreatedNow;
    }
}